import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { emit } from '@/lib/events';

const COPIED_FEEDBACK_MS = 1500;

export function ShareButton() {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const url = window.location.href;
    emit('share:clicked', { url_length: url.length });

    // Web Share API на мобиле (если поддерживается)
    if (typeof navigator !== 'undefined' && 'share' in navigator) {
      try {
        await navigator.share({ url, title: t('share.title') });
        return;
      } catch (err) {
        // user cancel — игнор; для остальных ошибок fallback на clipboard
        if ((err as DOMException)?.name === 'AbortError') return;
      }
    }

    // Fallback: clipboard
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
    } catch {
      // последний fallback — prompt с URL
      window.prompt(t('share.button'), url);
    }
  };

  return (
    <>
      <button
        onClick={handleShare}
        className="inline-flex h-9 min-w-9 items-center justify-center gap-1 rounded-md border border-[color:var(--color-ink-100)] px-2 text-sm text-[color:var(--color-ink-700)] hover:bg-[color:var(--color-paper-2)]"
        title={copied ? t('share.copied') : t('share.tooltip')}
        aria-label={t('share.aria')}
      >
        <span aria-hidden="true">🔗</span>
        <span className="hidden sm:inline">{copied ? t('share.copied') : t('share.button')}</span>
      </button>
      {/* Floating toast — fixed top-center so it's visible regardless of
          which page the user is on; the in-button text swap alone was too
          easy to miss (mobile hides the label entirely). */}
      {copied && (
        <div
          role="status"
          aria-live="polite"
          className="fixed left-1/2 top-4 z-[1300] -translate-x-1/2 rounded-full bg-[color:var(--color-ink-900)] px-4 py-2 text-sm font-medium text-[color:var(--color-paper)] shadow-lg"
        >
          {t('share.copied', { defaultValue: '✓ Link copied' })}
        </div>
      )}
    </>
  );
}
